import Typography from '@mui/joy/Typography';
import { makeTable } from "../../components/MakeTable";
import { Link, useNavigate } from "react-router-dom";
import moment from 'moment';
import { utcToLocal } from '../../utils/moment_utils';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useLanguageContext } from '../../context/LanguageContext';
import React from 'react';
import { Dropdown, IconButton, Menu, MenuItem, MenuButton } from '@mui/joy';
import { rethrow } from '../../utils/crud';
import { useInfo } from '../../utils/hooks/useInfo';
import { BlueLink } from '../../components/BlueLink';
import { UserMessagesApi } from '../../utils/crud/user_message_api';
import { useReloadPreservingListPage } from '../../provider/ListProvider';


let user_api = new UserMessagesApi();

const MenuPopup = ({ row }) => {
  const reload = useReloadPreservingListPage();
  const info = useInfo()
  const onDelete = (id) => user_api.delete(row.id).then(rethrow).then(() => reload()).catch(() => { info("Unknown error", "danger") });
  const { t } = useLanguageContext();
  return (
    <Dropdown>
      <MenuButton variant='plain'>
        <MoreHorizIcon />
      </MenuButton>
      <Menu sx={{ minWidth: 140, '& > *:not(:last-child)': { borderBottom: '1px solid var(--variant-outlinedBorder, var(--joy-palette-neutral-outlinedBorder, var(--joy-palette-neutral-300, #CDD7E1)))' } }}>
        {/* <Link to={`/user/${row.id}`} style={{ display: 'inline-block', textDecoration: 'none', width: '100%' }}><MenuItem>{t('Edit')}</MenuItem></Link> */}
        <MenuItem color='danger' onClick={() => onDelete(row.id)}>{t('Delete')}</MenuItem>
      </Menu>
    </Dropdown>
  )
}

export const MessagesTable = makeTable([
  {
    field: 'id',
    sortable: true,
    header_style: { // стиль tr
      width: 60,
    },
    label: 'ID',
    Element: ({ row }) => <BlueLink to={`/message/${row.id}`} level="body-xs">{row.id}</BlueLink>
  },
  {
    field: 'user_id',
    sortable: true,
    label: 'User ID',
    Element: ({ row }) => <BlueLink to={`/message/${row.id}`} level="body-xs">{row.user_id}</BlueLink>
  },
  {
    field: 'session_id',
    label: 'Session ID',
    Element: ({ row }) => <BlueLink to={`/message/${row.id}`} level="body-xs">{row.session_id}</BlueLink>
  },
  {
    field: 'user_name',
    sortable: true,
    label: 'User name',
    Element: ({ row }) => <Typography level="body-xs">{row.user_name}</Typography>
  },

  {
    field: 'email',
    sortable: true,
    label: 'E-mail',
    Element: ({ row }) => <Typography level="body-xs">{row.email}</Typography>
  },
  {
    field: 'phone',
    sortable: true,
    label: 'Phone',
    Element: ({ row }) => <Typography level="body-xs">{row.phone}</Typography>
  },
  {
    field: 'created_at',
    sortable: true,
    label: 'Created at',
    Element: ({ row }) => <Typography level="body-xs">{utcToLocal(row.created_at)}</Typography>
  },
  {
    field: 'is_read',
    sortable: true,
    label: 'Read',
    Element: ({ row }) => <Typography level="body-xs">{row.is_read ? "Read" : 'Unread'}</Typography>
  },
  {
    field: 'edit',
    label: '',
    row_style: { // стиль td
      textAlign: 'right',
    },
    Element: ({ row }) => <MenuPopup row={row} />
  }
])